<template>
  <section id="AboutPage">
    <div class="bg-light">
      <div class="container py-5">
        <div class="row h-100 align-items-center py-5">
          <div
            class="col-lg-6"
            data-aos="fade-in"
            data-aos-duration="600"
            data-aos-delay="600"
          >
            <h1>About us</h1>
            <p class="text-muted">
              “None of us, including me, ever do great things. But we can all do
              small things, with great love, and together we can do something
              wonderful.”<br />
            </p>
            <span>- Mother Teresa</span>
          </div>
          <div
            class="col-lg-6 d-none d-lg-block"
            data-aos="fade-in"
            data-aos-duration="600"
            data-aos-delay="1200"
          >
            <img
              src="../../public/about_assets/team-build.svg"
              alt=""
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white py-5">
      <div class="container py-5">
        <div class="row align-items-center mb-5">
          <div
            class="col-lg-6 order-2 order-lg-1"
            data-aos="fade-down"
            data-aos-duration="600"
            data-aos-delay="600"
          >
            <i class="fa fa-bar-chart fa-2x mb-3 text-primary"></i>
            <h2 class="font-weight-light">
              It's all started with a touch of love
            </h2>
            <p class="font-italic text-muted mb-4">
              Our Website is create by selected people who are the best in their
              industry. Each of them had shown that designing a website is not
              just a work. It's all about the love, the love we put in our
              product and we believe it shows.
            </p>
            <!-- <router-link to="/courses">
              <a href="#" class="tombol">Learn More</a>
            </router-link> -->
          </div>
          <div
            class="col-lg-5 px-5 mx-auto order-1 order-lg-2"
            data-aos="fade-up"
            data-aos-duration="600"
            data-aos-delay="1200"
          >
            <img
              src="../../public/about_assets/work.svg"
              alt=""
              class="img-fluid mb-4 mb-lg-0"
            />
          </div>
        </div>
        <div class="row align-items-center margin-top">
          <div
            class="col-lg-5 px-5 mx-auto"
            data-aos="fade-right"
            data-aos-duration="600"
            data-aos-delay="600"
          >
            <img
              src="../../public/about_assets/tech.svg"
              alt=""
              class="img-fluid mb-4 mb-lg-0"
            />
          </div>
          <div
            class="col-lg-6"
            data-aos="fade-left"
            data-aos-duration="600"
            data-aos-delay="1200"
          >
            <i class="fa fa-leaf fa-2x mb-3 icon"></i>
            <h2 class="font-weight-light">
              Created with state of the art technology
            </h2>
            <p class="font-italic text-muted mb-4">
              Our system is based on Vue, and supported with node.js to give you
              the best experience, reliability and security.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-light py-5">
      <div class="container">
        <div class="row mb-5">
          <h1 class="text-center">Our Team</h1>
        </div>
        <div class="row text-center d-flex flex-wrap justify-content-center">
          <div
            class="col-xl-3 col-sm-6 mb-5"
            data-aos="fade-in"
            data-aos-duration="600"
          >
            <div class="bg-white rounded shadow-sm py-5 px-4">
              <img
                src="../../public/Mat.png"
                alt=""
                width="100"
                class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"
              />
              <h5 class="mb-0">Samuel Matthew</h5>

              <ul class="social mb-0 list-inline mt-3">
                <li class="list-inline-item">
                  <a href="#" class="social-link"
                    ><a href="https://github.com/samuelmtthw" class="tombol"
                      >GitHub</a
                    ></a
                  >
                </li>
              </ul>
            </div>
          </div>
          <!-- End-->
        </div>
        <div class="row text-center d-flex flex-wrap justify-content-center">
          <div
            class="col-xl-3 col-sm-6 mb-5"
            data-aos="fade-in"
            data-aos-duration="600"
          >
            <div class="bg-white rounded shadow-sm py-5 px-4">
              <img
                src="../../public/Vina.jpeg"
                alt=""
                width="100"
                class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"
              />
              <h5 class="mb-0">Vina Eka Laylani</h5>

              <ul class="social mb-0 list-inline mt-3">
                <li class="list-inline-item">
                  <a href="https://github.com/vinaekalaylani" class="tombol"
                    >GitHub</a
                  >
                </li>
              </ul>
            </div>
          </div>

          <!-- End-->

          <!-- Team item-->
          <div
            class="col-xl-3 col-sm-6 mb-5"
            data-aos="fade-in"
            data-aos-duration="600"
          >
            <div class="bg-white rounded shadow-sm py-5 px-4">
              <img
                src="../../public/Bernhard.png"
                alt=""
                width="100"
                class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"
              />
              <h5 class="mb-0">Bernhard Winner</h5>

              <ul class="social mb-0 list-inline mt-3">
                <li class="list-inline-item">
                  <a href="#" class="social-link"
                    ><a href="https://github.com/brnhrdwnnr" class="tombol"
                      >GitHub</a
                    ></a
                  >
                </li>
              </ul>
            </div>
          </div>
          <!-- End-->

          <!-- Team item-->
          <div
            class="col-xl-3 col-sm-6 mb-5"
            data-aos="fade-in"
            data-aos-duration="600"
          >
            <div class="bg-white rounded shadow-sm py-5 px-4">
              <img
                src="../../public/colin.jpg"
                alt=""
                width="100"
                class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"
              />
              <h5 class="mb-0">Colin Maximillion Halim</h5>

              <ul class="social mb-0 list-inline mt-3">
                <li class="list-inline-item">
                  <a href="#" class="social-link"
                    ><a
                      href="https://github.com/ColinMaximillion"
                      class="tombol"
                      >GitHub</a
                    ></a
                  >
                </li>
              </ul>
            </div>
          </div>
          <!-- End-->

          <!-- Team item-->
          <div
            class="col-xl-3 col-sm-6 mb-5"
            data-aos="fade-in"
            data-aos-duration="600"
          >
            <div class="bg-white rounded shadow-sm py-5 px-4">
              <img
                src="../../public/Surya.jpeg"
                alt=""
                width="100"
                class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"
              />
              <h5 class="mb-0">Surya Aji Santosa</h5>

              <ul class="social mb-0 list-inline mt-3">
                <li class="list-inline-item">
                  <a href="#" class="social-link"
                    ><a href="https://github.com/suryaajis/" class="tombol"
                      >GitHub</a
                    ></a
                  >
                </li>
              </ul>
            </div>
          </div>
          <!-- End-->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutPage",
};
</script>

<style>
.tombol {
  color: #fff;
  background-color: #fc7901;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-style: italic;
  width: fit-content;
  border-radius: 5px;
  padding: 10px 15px;
  margin-right: 5px;
}

.tombol:hover {
  background-color: #eb5e0b;
}
.icon {
  color: #fc7901;
}

.margin-top {
  margin-top: 150px;
}

#AboutPage a {
  color: #fff;
}
</style>
